<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Softwares'"
        :buttons="[
          {
            title: 'Add Softwares',
            icon: 'fa fa-plus',
            emit: 'add',
          },
        ]"
        @add="addShow = true"
      ></cardHead>
      <dataTable
        :name="'Softwares'"
        :columnDefs="columnDefs"
        ref="agGrid"
        :data="data"
        :rowClassRules="{
          // row style function
          elektraWebRow: (params) => {
            // var numSickDays = params.data;
            return params?.data?.Id==6;
          },
        }"
        @openElektraWebRole="openElektraWebRole=true"
        @update="updateShow = { ...$event }"
        @remove="remove"
      ></dataTable>
      <upsert
        v-if="addShow || updateShow != null"
        :setModel="updateShow"
        @add="$refs.agGrid.addRow([$event])"
        @update="$refs.agGrid.changeRow('Id', $event)"
        @close="
          addShow = false;
          updateShow = null;
        "
      ></upsert>
    </div>
  </div>
  <elektraWebRoles v-if="openElektraWebRole" @close="openElektraWebRole=false"></elektraWebRoles>
</template>

<script>
import upsert from "./upsert";
import elektraWebRoles from "./elektrawebRoles/main.vue";
export default {
  name: "Softwares",
  components: { upsert,elektraWebRoles },
  data() {
    return {
      data: null,
      addShow: false,
      updateShow: null,
      openElektraWebRole:false,
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "P1Name",
          field: "P1Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "P2Name",
          field: "P2Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "P3Name",
          field: "P3Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "P4Name",
          field: "P4Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "P5Name",
          field: "P5Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Logo",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          cellRenderer: function(event) {
            return (
              "<img src='https://resbox.com/img/media/pms/" +
              event.data.Name +
              ".png' style='height:29px; margin-top: -2px;'/>"
            );
          },
        },
        {
          headerName: "",
          type: "action",
          width: 115,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-success openElektraWebRole",
              text: '<i class="fas fa-key"></i>',
              emit: "openElektraWebRole",
            },
            {
              classes: "btn btn-xs waves-effect waves-light btn-warning",
              text: '<i class="fas fa-pencil-alt"></i>',
              emit: "update",
            },
            {
              classes: "btn btn-xs waves-effect waves-light btn-danger",
              text: '<i class="fas fa-trash-alt"></i>',
              emit: "remove",
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
          cellRenderer: {
            _custom: {
              type: "component-definition",
              displayText: "BtnCellRenderer",
              tooltipText: "Component definition",
              file: "src/components/dataTable/btn-cell-renderer.vue",
            },
          },
          cellRendererParams: {
            clicked: {
              _custom: {
                type: "function",
                displayText:
                  '<span style="opacity:.8;margin-right:5px;">function</span> <span style="white-space:nowrap;">clicked(field)</span>',
                tooltipText:
                  "<pre>function clicked(field) {\n              app.$emit(field.emit, field.data);\n            }</pre>",
              },
            },
          },
        },
      ],
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Softwares`).then((response) => {
      this.data = response.data;
    });
  },
  methods: {
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning",
        text:
          "Are you sure you want to delete the software named " +
          item.Name +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`Softwares/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Software deleted successfully.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>
<style scoped>
  /deep/ .openElektraWebRole{
    display: none;
  }
  /deep/ .elektraWebRow .openElektraWebRole{
    display: inline-block;
  }
</style>
